import React from 'react';

// This is a reusable card component for a single package.
const PackageCard = ({ image, title, duration, price }) => {
  const styles = {
    card: {
      border: '1px solid #eee',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      fontFamily: 'Arial, sans-serif'
    },
    image: {
      width: '100%',
      height: '200px',
      objectFit: 'cover',
    },
    content: {
      padding: '1.5rem',
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      margin: '0 0 0.5rem 0',
    },
    duration: {
      fontSize: '0.9rem',
      color: '#666',
      marginBottom: '1rem',
    },
    priceRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    price: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: 'var(--primary, #007bff)', // Use variable
    },
    button: {
      backgroundColor: '#007bff',
      color: 'white',
      padding: '0.6rem 1.2rem',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    }
  };

  return (
    <div style={styles.card}>
      <img src={image} alt={title} style={styles.image} />
      <div style={styles.content}>
        <h3 style={styles.title}>{title}</h3>
        <p style={styles.duration}>{duration}</p>
        <div style={styles.priceRow}>
        <span style={styles.price}>${price}</span>
        <button className="btn btn-primary">View Details</button>
      </div>
      </div>
    </div>
  );
};


const FeaturedPackages1 = () => {
  // In a real app, this data would come from an API call
  const packages = [
    { image: 'https://images.pexels.com/photos/1618269/pexels-photo-1618269.jpeg', title: 'Amazing Thailand', duration: '7 Days / 6 Nights', price: '1200' },
    { image: 'https://images.pexels.com/photos/2161449/pexels-photo-2161449.jpeg', title: 'Mountain Adventure in Swiss', duration: '5 Days / 4 Nights', price: '2500' },
    { image: 'https://images.pexels.com/photos/3225528/pexels-photo-3225528.jpeg', title: 'Bali Beach Escape', duration: '6 Days / 5 Nights', price: '1500' },
  ];

  const styles = {
    section: {
      padding: '4rem 2rem',
      backgroundColor: '#ffffff',
    },
    title: {
      textAlign: 'center',
      fontSize: '2.5rem',
      marginBottom: '3rem',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', // Responsive grid
      gap: '2rem',
      maxWidth: '1200px',
      margin: '0 auto',
    }
  };

  return (
    <section style={styles.section}>
      <h2 style={styles.title}>Our Featured Packages</h2>
      <div style={styles.grid}>
        {packages.map((pkg, index) => (
          <PackageCard key={index} {...pkg} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedPackages1;